<script setup lang="ts">
import HeroBackground1 from '@/components/Icons/ProductBackground-1.vue'
import HeroBackground2 from '@/components/Icons/ProductBackground-2.vue'

interface Props {
  title: string | null;
  subtitle?: string | null | undefined;
}

defineProps<Props>()
</script>

<template>
  <section class="UiHero container">
    <div class="UiHero__meta">
      <h1 class="UiHero__title">
        {{ title }}
      </h1>
    </div>
    <p v-if="subtitle" class="UiHero__price">{{ subtitle }}</p>
  </section>
</template>

<style lang="scss" scoped>
h1, h2, h3, h4 {
  margin-bottom: 0;
}

.UiHero {
  display: flex;
  column-gap: 20px;
  justify-content: space-between;
  align-items: center;
  margin-bottom: fluid(40, 32);
  border-radius: var(--rounded-xxl);
  background: var(--color-bg-banner);
  padding-block: 40px;

  @include mobile {
    flex-direction: column;
    align-items: start;
    row-gap: 12px;
    padding: 20px 14px;
    max-width: calc(100% - 4px);
  }

  &__meta {
    display: flex;
    row-gap: fluid(16, 8);
    flex-direction: column;
    max-width: 668px;
  }

  &__subtitle {
    opacity: 0.6;
    font-weight: 600;
    font-size: fluid(20, 16);
    line-height: 1.35;
    max-width: 600px;
  }

  &__price {
    color: var(--color-accent-alt);
    font-weight: 700;
    font-size: fluid(28, 22);

    @media screen and (min-width: 768px) {
      text-align: right;
      width: 400px;
    }
  }
}
</style>
